import React, { useEffect, useState } from "react";
import { fetchMyAccess } from "../services/User";
import AccessExpired from "./AccessExpired";

export default function AccessGuard({ children }) {
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("token")) return;

    let active = true;

    const check = async () => {
      const info = await fetchMyAccess();
      if (active) setExpired(!!(info && info.expired));
    };

    check();
    const timer = setInterval(check, 60 * 1000); // re-check every minute

    return () => {
      active = false;
      clearInterval(timer);
    };
  }, []);

  return expired ? <AccessExpired /> : children;
}
